if (!customElements.get('product-media-gallery-mobile-modal')) {
  customElements.define('product-media-gallery-mobile-modal', class ProductMediaGalleryMobileModal extends HTMLElement {
    constructor() {
      super();

      this.triggers = document.querySelectorAll('[data-product-media-gallery-mobile-modal-trigger]');
      this.closeButton = this.querySelectorAll('[data-product-media-gallery-mobile-modal-close]');
      this.innerModalCarouselButtons = this.querySelectorAll('[data-product-modal-gallery-quick-trigger]');
      this.medias = this.querySelectorAll('.gallery-mob__item');
    }

    connectedCallback() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', this.openModal.bind(this));
      });

      this.closeButton.forEach(button => {
        button.addEventListener('click', this.closeModal.bind(this));
      });

      this.innerModalCarouselButtons.forEach(button => {
        button.addEventListener('click', this.swapImage.bind(this));
      });
    }

    openModal(event) {
      this.classList.add('active');
      this.swapImage(event);
      document.body.classList.add('overflow-hidden');
    }

    closeModal() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }

    swapImage(event) {
      const clickedEl = event.currentTarget;
      const mediaId = clickedEl.dataset.mediaId;

      this.medias.forEach(media => {
        if (media.dataset.mediaId === mediaId) {
          media.classList.remove('hidden');
          const img = media.querySelector('img');
          if (img && !img.parentElement.classList.contains('pinch-zoom-container')) {
            this.setupPinchZoom(img);
          }
        } else {
          media.classList.add('hidden');
        }
      });
    }

    setupPinchZoom(el) {
      if (!el || el._pz) return;

      const init = () => {
        const pz = new PinchZoom.default(el, {
          draggableUnzoomed: false
        });

        el._pz = pz;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const rect = pz.container.getBoundingClientRect();

            const center = {
              x: rect.width / 2,
              y: rect.height / 2
            };

            pz.scaleTo(2, center);
            pz.offset = pz.sanitizeOffset(pz.offset);
            pz.update();
          });
        });
      };

      if (el.complete) {
        init();
      } else {
        el.onload = init;
      }
    }
  });
}
